import { defineComponent, computed, createBlock, createCommentVNode, openBlock, withCtx, createElementBlock, Fragment, renderList, resolveDynamicComponent, mergeProps } from "vue";
import _sfc_main$1 from "../lib/Wrapper.vue.js";
import { usePrismic } from "../usePrismic.js";
import { TODOSliceComponent } from "./TODOSliceComponent.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{ name: "SliceZone" },
  __name: "SliceZone",
  props: {
    slices: {},
    components: {},
    defaultComponent: {},
    context: {},
    wrapper: {}
  },
  setup(__props) {
    const props = __props;
    const { options } = usePrismic();
    const renderedSlices = computed(() => {
      return props.slices.map((slice, index) => {
        var _a, _b;
        const type = "slice_type" in slice ? slice.slice_type : slice.type;
        const key = "id" in slice && typeof slice.id === "string" ? slice.id : `${index}-${JSON.stringify(slice)}`;
        const is = ((_a = props.components) == null ? void 0 : _a[type]) || props.defaultComponent || ((_b = options.components) == null ? void 0 : _b.sliceZoneDefaultComponent);
        if (!is) {
          return { is: TODOSliceComponent, key, props: { slice } };
        }
        if (slice.__mapped) {
          const { __mapped, ...mappedProps } = slice;
          return { is, key, props: mappedProps };
        }
        return {
          is,
          key,
          props: {
            slice,
            index,
            context: props.context,
            slices: props.slices
          }
        };
      });
    });
    return (_ctx, _cache) => {
      return _ctx.slices ? (openBlock(), createBlock(_sfc_main$1, {
        key: 0,
        wrapper: _ctx.wrapper
      }, {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList(renderedSlices.value, (renderedSlice) => {
            return openBlock(), createBlock(resolveDynamicComponent(renderedSlice.is), mergeProps({
              key: renderedSlice.key,
              ref_for: true
            }, renderedSlice.props), null, 16);
          }), 128))
        ]),
        _: 1
      }, 8, ["wrapper"])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=SliceZone.vue.js.map
